
import {getAllStatus} from '../../components/status/status-data'
export const changePopup = (el) => {
    if (el.querySelector('.leaflet-popup-content-wrapper') !== null) {
        //el.querySelector('.leaflet-popup-content-wrapper').style.background = '#2c3e50';
        //el.querySelector('.leaflet-popup-content-wrapper').style.color = 'blue'
    }
}
export const attributionControl = (status) => {
    let attrib=document.getElementsByClassName('mapboxgl-ctrl-bottom-right')[1]
    attrib.style.left = '10px'
    attrib.style.width = '330px'
    attrib.style.top = '650px'
    attrib.style.height = '40px'
    attrib.style.opacity = '0.7'
    attrib.querySelector('.mapboxgl-ctrl').style.background = '#1c1c1d';
    attrib.querySelector('.mapboxgl-ctrl-attrib').querySelectorAll('a').forEach(el => { el.style.color = "white" })
    attrib.querySelector('.mapboxgl-ctrl-attrib').querySelector('.mapboxgl-ctrl-attrib-inner').style.marginTop='5px'
    attrib.querySelector('.mapboxgl-ctrl-attrib').querySelector('.mapboxgl-ctrl-attrib-inner').style.marginLeft='5px'
    attrib.querySelector('.mapboxgl-ctrl-attrib').querySelector('.mapboxgl-ctrl-attrib-inner').style.marginBottom='5px'
    /*
    margin-top: 5px;
    margin-left: 5px;
    margin-bottom: 5px;
    */
    attrib.style.display = status?'block':'none'
}
export const changeBadge = (el) => {
    let properties=getAllStatus()[0]
    if (el.querySelector('.page-content') !== null) {
        //el.querySelector('.page-content').style.overflow = 'hidden'
    }
    if (el.querySelector('.badgeAlerta') !== null) {
        //el.querySelector('.badgeAlerta').querySelector('.badge').style.visibility = properties.badge1 ? 'visible' : 'hidden'
    }
    if (el.querySelector('.badgePcalor') !== null) {
        //el.querySelector('.badgePcalor').querySelector('.badge').style.visibility = properties.badge2 ? 'visible' : 'hidden'
    }
    if (el.querySelector('.badgeMosaicos') !== null) {
        //el.querySelector('.badgeMosaicos').querySelector('.badge').style.visibility = properties.badge3 ? 'visible' : 'hidden'
    }
    if (el.querySelector('.badgeAquemadas') !== null) {
        //el.querySelector('.badgeAquemadas').querySelector('.badge').style.visibility = properties.badge4 ? 'visible' : 'hidden'
    }
    if (el.querySelector('.badgeComplementaria') !== null) {
        //el.querySelector('.badgeComplementaria').querySelector('.badge').style.visibility = properties.badge5 ? 'visible' : 'hidden'
    }
    if (el.querySelector('.badgeFiltro') !== null) {
        //el.querySelector('.badgeFiltro').querySelector('.badge').style.visibility = properties.badge6 ? 'visible' : 'hidden'
    }
    if (el.querySelector('.badgeMiconsulta') !== null) {
        //el.querySelector('.badgeMiconsulta').querySelector('.badge').style.visibility = properties.badge7 ? 'visible' : 'hidden'
    }
    if (el.querySelector('.badgeAnalisis') !== null) {
        //el.querySelector('.badgeAnalisis').querySelector('.badge').style.visibility = properties.badge8 ? 'visible' : 'hidden'
    }
    if (el.querySelector('.badgeHistorico') !== null) {
        //el.querySelector('.badgeHistorico').querySelector('.badge').style.visibility = properties.badge9 ? 'visible' : 'hidden'
    }
    if (el.querySelector('.date1') !== null) {
        //el.querySelector('.date1').querySelector('.input-with-value').style['background-color'] = '#0960bc'
        //el.querySelector('.date1').querySelector('.input-with-value').style['padding-left'] = '4px'
    }
    if (el.querySelector('.date2') !== null) {
        //el.querySelector('.date2').querySelector('.input-with-value').style['background-color'] = '#0960bc'
        //el.querySelector('.date2').querySelector('.input-with-value').style['padding-left'] = '4px'
    }
}